export const
    amber_a = require('./amber_a.jpg'),
    cate_smithson = require('./cate_smithson.jpg'),
    jessie_and_sam = require('./jessie_and_sam.jpg'),
    joah_spearman = require('./joah_spearman.jpg'),
    rob_h = require('./rob_h.jpg'),
    robert_m = require('./robert_m.jpg'),
    victoria_n = require('./victoria_n.jpg')